import React from 'react';
import { AboutContainer, Section } from './About.Styles';

const About: React.FC = () => {
  return (
    <AboutContainer>
      <Section>
        <h1>Nomads Ice Hockey Club</h1>
        <br />
        <p>
        We’re a group of hockey players from different teams who kept running into each other at tournaments and loved playing together (and against each other). So we thought, why not make it official?</p>
        <br />
        <p>
        Our team brings together players from Nottingham, Sheffield, Peterborough and Leeds. We don’t have a home rink, and we don’t train every week, but when we do get on the ice it's all about having a good time, playing hard and keeping the love for the game alive. Catch us at scrims and tournaments across the UK!</p>
      </Section>
    </AboutContainer>
  );
};

export default About; 